import React from "react";
import { Button } from "primereact/button";
import styles from "./DirectionsModal.module.scss";

const DirectionsModal = ({ visible, onHide, children }) => {
    if (!visible) return null;

    return (
        <div className={styles.modalOverlay} onClick={onHide}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h3 className={styles.modalTitle}>
                        <i className="pi pi-map" />
                        Directions
                    </h3>
                    <Button icon="pi pi-times" rounded text severity="secondary" className={styles.closeButton} onClick={onHide} />
                </div>
                <div className={styles.modalBody}>{children}</div>
            </div>
        </div>
    );
};

export default DirectionsModal;
